import { useEffect, useState } from "react";

const FLAG_KEY = "moldex-admin-mode";

/**
 * Admin mode is opted into by visiting `?admin=1` once per browser session.
 * The flag persists in sessionStorage so subsequent navigation (folder clicks,
 * card opens) doesn't drop the mode. Clearing the tab or visiting `?admin=0`
 * turns it back off.
 */
export function useAdminMode(): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => readInitial());

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("admin")) {
      const v = params.get("admin");
      if (v === "1" || v === "true") {
        sessionStorage.setItem(FLAG_KEY, "1");
        setEnabled(true);
      } else {
        sessionStorage.removeItem(FLAG_KEY);
        setEnabled(false);
      }
    }
  }, []);

  return enabled;
}

function readInitial(): boolean {
  try {
    if (typeof window === "undefined") return false;
    const params = new URLSearchParams(window.location.search);
    if (params.get("admin") === "1" || params.get("admin") === "true") return true;
    if (params.get("admin") === "0" || params.get("admin") === "false") return false;
    return sessionStorage.getItem(FLAG_KEY) === "1";
  } catch {
    return false;
  }
}
